import axios from 'axios';
import GlobalConfigs from "../configs/GlobalConfigs";
import * as Apis from '../apis/Apis';

/* API call get class data */
export function getClassStandardList() {
    return axios({
        url: GlobalConfigs.API_URL + Apis.GET_CLASS_STANDARD_LIST_API,
        method: "GET",
        headers: {
            ContentType: "application/json",
            // Authorization: `Bearer ${token}`
        },
    });
}

export function getClassStandardByToken() {
    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;
    return axios({
        url: GlobalConfigs.API_URL + Apis.GET_CLASS_STANDARD_LIST_AFTER_LOGIN_API,
        method: "GET",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
    });
}

export function getArchiveStandardList() {
    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;
    return axios({
        url: GlobalConfigs.API_URL + Apis.GET_ARCHIVE_STANDARD_LIST_API,
        method: "GET",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
    });
}